import { Controller } from '@hotwired/stimulus'
import { Turbo } from '@hotwired/turbo-rails'

export default class extends Controller {
  static values = {
    frame: String,
    storageKey: String,
    url: String
  }

  connect () {
    if (!this._timerInProgress()) return

    Turbo.visit(this.urlValue, { frame: this.frameValue })
  }

  _timerInProgress () {
    const stored = window.localStorage.getItem(this.storageKeyValue)
    if (!stored) return false

    try {
      return Number(JSON.parse(stored).startedAt) > 0
    } catch {
      return false
    }
  }
}
